export function flattenJSON(jsonObj: any, parentKey: string = '', sep: string = '-'): any {
    let items: any = {};
    for (const key in jsonObj) {
      if (jsonObj.hasOwnProperty(key)) {
        const value = jsonObj[key];
        const newKey = parentKey ? `${parentKey}${sep}${key}` : key;
        if (typeof value === 'object' && value !== null) {
          const flattened = flattenJSON(value, newKey, sep);
          items = { ...items, ...flattened };
        } else {
          items[newKey] = value;
        }
      }
    }
    return items;
  }
  
  // Sample JSON object (replace this with your actual JSON)
  